const paymentMethodsMap = {
  CREDIT_CARD: 'checkout.lib.components.common.paymentMethod.text.creditCard',
  ECHECK: 'checkout.lib.components.common.paymentMethod.text.echeck',
  CREDIT_BALANCE: 'checkout.lib.components.common.paymentMethod.text.creditBalance',
  CHECK: 'checkout.lib.components.payment.switch.text.check',
  CASH: 'checkout.lib.components.payment.switch.text.cash',
  PINPAD: 'checkout.lib.components.payment.switch.text.pinpad',
  ALIPAY: 'checkout.lib.components.payment.switch.text.alipay',
  WECHAT: 'checkout.lib.components.payment.switch.text.wechatPay',
  IDEAL: 'checkout.lib.components.payment.switch.text.idealPay',
  APPLEPAY: 'checkout.lib.components.payment.switch.text.applePay',
  GOOGLEPAY: 'checkout.lib.components.payment.switch.text.googlePay',
};

export default paymentMethodsMap;
